import {
    FaLightbulb,
    FaMobileAlt,
    FaUserCircle,
    FaChartLine
} from 'react-icons/fa';

export default function IntuitiveApp() {
    const features = [
        { name: 'User-Friendly Interface', description: 'Intuitive experience for employers and employees.', icon: FaUserCircle },
        { name: 'Jobsite Management', description: 'Manage all your jobsites and employees from a single dashboard.', icon: FaMobileAlt },
        { name: 'Worker Management', description: 'Keep track of your workers, their schedules, and attendance with ease.', icon: FaLightbulb },
        { name: 'Real-time Tracking', description: 'Monitor attendance and job progress in real time.', icon: FaChartLine },
        { name: 'Seamless Integrations', description: 'Integrates with your payroll and accounting software.', icon: FaMobileAlt },
        { name: 'Customizable Reporting', description: 'Generate focused reports for workforce and operations insights.', icon: FaUserCircle },
    ];

    return (
        <section className="bg-bg py-20 sm:py-24">
            <div className="mx-auto max-w-6xl px-6">
                <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
                    <div className="order-2 lg:order-1">
                        <p className="text-eyebrow uppercase text-brand">
                            Intuitive App
                        </p>
                        <h2 className="mt-4 text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
                            Everything in one interface your team can learn fast.
                        </h2>
                        <p className="mt-5 text-base leading-7 text-ink-2">
                            Manage jobsites, workers, attendance, and reporting from a
                            single place with fewer clicks and less confusion.
                        </p>

                        <dl className="mt-10 grid gap-4 sm:grid-cols-2">
                            {features.map((feature) => (
                                <div key={feature.name} className="rounded-2xl border border-border bg-surface p-4">
                                    <dt className="flex items-center gap-3 text-sm font-semibold text-ink">
                                        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand/10 text-brand">
                                            <feature.icon className="h-4 w-4" aria-hidden="true" />
                                        </div>
                                        {feature.name}
                                    </dt>
                                    <dd className="mt-2 text-sm leading-6 text-ink-3">
                                        {feature.description}
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                    <div className="order-1 flex items-center justify-center lg:order-2 lg:justify-end">
                        <img
                            src="/phoneApp.png"
                            alt="TimeStat Mobile App"
                            className="w-full max-w-md rounded-3xl border border-border bg-surface p-3 shadow-[0_20px_80px_rgba(28,25,23,0.08)]"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
